import React from "react";
import "../Provenienze.scss";
import { AddIcon }  from "../../../assets/icons";
import CustomTooltip from "../../CustomTooltip";

  const ProvenienzeHeader = ({
    edit = false,
    onOpenModal,
    location = null,
  }) => {
    return (
      <div className="provenienze-header">
          <p className="provenienze-header-title">Provenienze</p>
          {location && (
            <p className="provenienze-header-location">Comune/Sito: <b>{location}</b></p>
          )}
        {edit && (
          <CustomTooltip text="Aggiungi provenienza">
            <button className="provenienze-button"  onClick={onOpenModal}>
                <AddIcon fillColor="var(--archeo-color)" />
            </button>
          </CustomTooltip>
        )}
      </div>
    );
  };

export default ProvenienzeHeader;
